"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../../utils/helpers");
var _ButtonsModule = _interopRequireDefault(require("../../scss/buttons/Buttons.module.scss"));
function Button(_ref) {
  let {
    type = "",
    label = "",
    href = "",
    varient = "",
    size = "",
    classname = "",
    customColors = {
      bgColor: "",
      bgHoverColor: "",
      color: "",
      hoverColor: "",
      borderColor: "",
      borderHoverColor: ""
    },
    onClick = () => {},
    ...attributes
  } = _ref;
  const varientClass = varient === '' ? "" : "btn--".concat(varient);
  const sizeClass = size === '' ? "" : "btn--".concat(size);
  const cssVars = customColors.bgColor !== "" ? {
    '--button-bg-color': customColors.bgColor,
    '--button-hover-bg-color': customColors.bgHoverColor === '' ? customColors.bgColor : customColors.bgHoverColor,
    '--button-color': customColors.color,
    '--button-hover-color': customColors.hoverColor === '' ? customColors.color : customColors.hoverColor,
    '--button-border-color': customColors.borderColor === '' ? customColors.bgColor : customColors.borderColor,
    '--button-hover-border-color': customColors.borderHoverColor === '' ? customColors.borderColor === '' ? customColors.bgColor : customColors.borderHoverColor : customColors.borderHoverColor
  } : null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, href === '' ? /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    type: type,
    onClick: onClick,
    className: (0, _helpers.classes)([classname, _ButtonsModule.default['btn'], 'btn', varient === '' ? '' : _ButtonsModule.default[varientClass], size === '' ? '' : _ButtonsModule.default[sizeClass]]),
    style: cssVars
  }, attributes), label) : /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    href: href,
    className: (0, _helpers.classes)([classname, _ButtonsModule.default['btn'], 'btn', varient === '' ? '' : _ButtonsModule.default[varientClass], size === '' ? '' : _ButtonsModule.default[sizeClass]]),
    style: cssVars
  }, attributes), label));
}
var _default = exports.default = Button;